import { Trans } from '@lingui/react/macro';
import { colorSystem, Flexbox } from '@luminovo/design-system';
import { TableCell } from '@mui/material';
import { CheckIcon, XIcon } from 'lucide-react';

import { Column, Row } from './types';

export const YesState = (): JSX.Element => {
    return (
        <Flexbox
            gap={4}
            sx={{
                color: colorSystem.neutral[8],
                alignItems: 'center',
            }}
        >
            <CheckIcon size={20} />
            <Trans>Yes</Trans>
        </Flexbox>
    );
};

export const NoState = (): JSX.Element => {
    return (
        <Flexbox
            gap={4}
            sx={{
                color: colorSystem.neutral[6],
                alignItems: 'center',
            }}
        >
            <XIcon size={20} />
            <Trans>No</Trans>
        </Flexbox>
    );
};

/**
 * A default implementation of showing boolean yes / no values
 */
export function defaultBooleanColumn<TRowData, TContext = undefined>(
    column: Omit<Column<TRowData, TContext>, 'render' | 'renderHead'>,
    extractBool: (data: Row<TRowData>, context: TContext) => boolean,
): Column<TRowData, TContext> {
    return {
        render: (data, context) => {
            return <TableCell>{extractBool(data, context) ? <YesState /> : <NoState />}</TableCell>;
        },
        ...column,
    };
}
